import { useEffect } from "react";
import { useLocale } from "@packsize/localization";

import { useUser } from "../use-user";
import { useIdentityClient } from "../use-identity-client";

export const useLocalizationSetup = () => {
	const identityClient = useIdentityClient();
	const { setLocale, currentLocale } = useLocale();
	const { currentUser } = useUser();

	useEffect(() => {
		if (currentUser === undefined || currentUser === null) {
			return;
		}

		if (Boolean(currentUser.preferredLanguage) === false) {
			return;
		}

		setLocale(currentUser.preferredLanguage, "postAuth");
	}, [currentUser, setLocale]);

	useEffect(() => {
		if (currentUser !== undefined && currentUser !== null) {
			return;
		}

		if (currentLocale.source !== "postAuth") {
			return;
		}

		setLocale(currentLocale.locale, "preAuth");
	}, [currentLocale.locale, currentLocale.source, currentUser, setLocale]);

	useEffect(() => {
		if (currentUser === undefined || currentUser === null) {
			return;
		}

		if (currentLocale === undefined || currentLocale.source !== "postAuth") {
			return;
		}

		if (currentUser.preferredLanguage === currentLocale.locale) {
			return;
		}

		identityClient.client.updateUserLanguage({
			preferredLanguage: currentLocale.locale,
		});
	}, [currentLocale, currentUser, identityClient.client]);
};
